import { lazy } from "react";

export const PublicAppLazy = lazy(() => import("./PublicApp"));
